import classNames from 'classnames';
import React, { forwardRef, InputHTMLAttributes, Ref } from 'react';

import { Text, TextColor, TextVariant } from '../../Text';
import {
  errorMessage,
  errorMessageStyle,
  layoutInvisible,
  layoutSmall,
  select,
  select__label,
} from './Select.module.scss';

interface Props extends InputHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  ref?: Ref<HTMLSelectElement>;
  layout?: 'small' | 'medium' | 'invisible';
}

export const Select: React.FC<Props> = forwardRef(
  (
    { children, error, label, layout = 'medium', ...rest },
    ref,
  ): JSX.Element => (
    <label>
      {!!label && (
        <Text
          className={select__label}
          tag="div"
          variant={TextVariant.BODY_SMALL}
          htmlFor="state"
        >
          {label}
        </Text>
      )}
      <select
        className={classNames(select, {
          [errorMessageStyle]: !!error,
          [layoutSmall]: layout === 'small',
          [layoutInvisible]: layout === 'invisible',
        })}
        {...rest}
        {...{ ref }}
      >
        {children}
      </select>

      {!!error && (
        <Text
          className={errorMessage}
          tag="div"
          role="alert"
          variant={TextVariant.BODY_SMALL}
          color={TextColor.RED}
        >
          {error}
        </Text>
      )}
    </label>
  ),
);
